import { FC, memo } from "react"

import If from "../../if"
import Badge from "../../badge"
import {
  DEFAULT_DATE_SLASH_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../utils"
import { PricingSet } from "../../../../types"

type Props = {
  pricingSet?: PricingSet
  isDefault?: boolean
}

const LoanProgramCardBody: FC<Props> = memo(({ pricingSet, isDefault }) => (
  <div className="flex justify-between mt-4">
    <div className="flex flex-col">
      <div className="flex items-center">
        <span className="font-medium pe-2">{pricingSet?.name}</span>
        {isDefault && <Badge.Danger>Default</Badge.Danger>}
      </div>
      <If
        condition={!!pricingSet?.updated}
        then={
          <div className="text-sm text-gray-400">
            {`Created on ${formatDateTimeFromTimestamp(
              pricingSet!.updated,
              DEFAULT_DATE_SLASH_FORMAT
            )}`}
          </div>
        }
      />
    </div>
    {/* TODO: Remove comment after adding functionality */}
    {/* <div className="flex relative">
      <RowOptions
        className="absolute right-0 text-gray-400"
        menuIconClassName="text-gray-400"
        actions={[
          {
            label: "Mark as default",
            icon: Slice,
            onClick: () => {},
            iconClassName: "text-gray-400"
          },
          {
            label: "Edit",
            icon: Pencil,
            onClick: () => {},
            iconClassName: "text-gray-400"
          }
        ]}
        deleteAction={() => {}}
      />
    </div> */}
  </div>
))

export default LoanProgramCardBody
